import { Action } from '@ngrx/store';
import { updateModelType } from './UpdateModelAction';
import { IAutoSave } from '../../IAutoSave';
import { AbstractControl } from '@angular/forms/src/model';

export function updateModelSuccessType<TParentModel, TModel>(module: string, parentType: { new(): TParentModel; }, type: { new(): TModel; } | string): string {
  return `${updateModelType(module, parentType, type)} Success`;
}

export function updateModelSuccessTypeByUpdateType(type: string): string {
  return `${type} Success`;
}

export class UpdateModelSuccessAction<TParentModel, TModel> implements Action {
  readonly type: string;

  constructor(module: string, parentType: { new(): TParentModel; }, modelType: { new(): TModel; } | string, public payload: { key: string, model: TModel, control: IAutoSave & AbstractControl }) {
    this.type = updateModelSuccessType(module, parentType, modelType);
  }
}



// WEBPACK FOOTER //
// ./src/app/pillar/workspace/store/actions/UpdateModelSuccessAction.ts